import React, { Component, useEffect, useRef, useState} from 'react';
import { Messages } from 'primereact/messages';
import { useTranslation } from 'react-i18next';
import { Card } from 'primereact/card';
import KeyValue from './KeyValue';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import CatService from '../../service/CatService';

function MainPage(props){
  const {t} = useTranslation();
  const nav = useNavigate();

  const messages = useRef(null);
  const [progStats,setProgStats] = useState([]);

  useEffect(()=>{
    CatService.getCatStats()
      .then((ret)=>{
        var ps=[
          {key:t('Number of programs'),value:ret.data['ROOT']},
          {key:t('Number of courses'),value:ret.data['COURSE']},
          {key:t('Number of topics'),value:ret.data['TOPIC']},
          {key:t('Number of outcome'),value:ret.data['OUTCOME']}
        ]
        setProgStats(ps);
      })
      .catch((err)=>{showError(err.response.data.message)});
  },[]);

  const showError=(msg)=>{
    messages.current.show([
      {sticky: false, severity: 'error', summary: t('error'), detail: t("error."+msg), closable: true}]);
  }
  return (
    <>
    <div className="grid">
      <div className="col-12"><Messages ref={messages}/></div>
      <div className="col-6 flex flex-column">
        <Card title={t('Curriculum')}>
          <KeyValue values={progStats}/>
          <Button label={t("Open_Curriculum")} className='mt-2' onClick={()=>nav('/curriculum')} severity='secondary'/>
        </Card>
      </div>
      <div className="col-6 flex flex-column">
        <Card title={t('Item Bank')}>
        </Card>
      </div>
    </div >
    </>    
  )
}
export default MainPage;
